import { Divider } from "antd";
import SpepInstructionCard from "./step-instruction-card";

export default function MaterialInstruction() {
  return (
    <div className="linking-group--right--content p-1 pr-12">
      <SpepInstructionCard
        title="Step 1:"
        detail="Select a Material from the dropdown."
      />
      <SpepInstructionCard
        title="Step 2:"
        detail="  To associate an Activity or Submittal, click Edit to open a list here."
      />
      <SpepInstructionCard
        title="Step 3:"
        detail="Click Save to confirm changes."
      />
      <div>
        <Divider />
        <SpepInstructionCard
          title="Note:"
          detail="Materials can be associated directly to other Materials, by switching the Setting on."
        />
      </div>
    </div>
  );
}
